import { DataAPIService } from './AxiosAPIService';
import { logger } from './SharedService';
import {
  LocationDetailsResponse,
  LocationVehiclesResponse,
  LocationDevicesResponse,
  LocationDriversResponse,
  LocationByIdsRequest,
} from '../types/Maps';

const MAPS_ENDPOINT = '/locations';

export const getVehiclesLocations = async (
  fleetId: string,
  query?: string,
): Promise<LocationVehiclesResponse> => {
  const { data } = await DataAPIService
    .api.get<LocationVehiclesResponse>(`${fleetId}${MAPS_ENDPOINT}/vehicles${query}`);
  logger.info('GET', 'RESPONSE', 'getVehiclesLocations', data);
  return data;
};

export const getVehicleDetailsLocations = async (
  fleetId: string,
  id: string,
  query?: string,
): Promise<LocationDetailsResponse> => {
  const { data } = await DataAPIService
    .api.get<LocationDetailsResponse>(`${fleetId}${MAPS_ENDPOINT}/vehicles/${id}${query}`);
  logger.info('GET', 'RESPONSE', 'getVehicleDetailsLocations', data);
  return data;
};

export const getDriversLocations = async (
  fleetId: string,
  query?: string,
): Promise<LocationDriversResponse> => {
  const { data } = await DataAPIService
    .api.get<LocationDriversResponse>(`${fleetId}${MAPS_ENDPOINT}/drivers${query}`);
  logger.info('GET', 'RESPONSE', 'getDriversLocations', data);
  return data;
};

export const getDriverDetailsLocations = async (
  fleetId: string,
  id: string,
  query?: string,
): Promise<LocationDetailsResponse> => {
  const { data } = await DataAPIService
    .api.get<LocationDetailsResponse>(`${fleetId}${MAPS_ENDPOINT}/drivers/${id}${query}`);
  logger.info('GET', 'RESPONSE', 'getDriverDetailsLocations', data);
  return data;
};

export const getDevicesLocations = async (
  fleetId: string,
  query?: string,
): Promise<LocationDevicesResponse> => {
  const { data } = await DataAPIService
    .api.get<LocationDevicesResponse>(`${fleetId}${MAPS_ENDPOINT}/devices${query}`);
  logger.info('GET', 'RESPONSE', 'getDevicesLocations', data);
  return data;
};

export const getDeviceDetailsLocations = async (
  fleetId: string,
  id: string,
  query?: string,
): Promise<LocationDetailsResponse> => {
  logger.info('GET', 'REQUEST', 'getDeviceDetailsLocations', `${fleetId}${MAPS_ENDPOINT}/devices/${id}${query}`);
  const { data } = await DataAPIService
    .api.get<LocationDetailsResponse>(`${fleetId}${MAPS_ENDPOINT}/devices/${id}${query}`);
  logger.info('GET', 'RESPONSE', 'getDeviceDetailsLocations', data);
  return data;
};

export const getVehicleDetailsLocationsByIds = async (payload: LocationByIdsRequest): Promise<LocationDetailsResponse[]> => {
  const deletePromises = payload.ids?.map(async (id) => {
    const { data } = await DataAPIService.api.get<LocationDetailsResponse>(`${payload.fleetId}${MAPS_ENDPOINT}/devices/${id}${payload.query || ''}`);
    return data;
  });

  const results = await Promise.all(deletePromises);
  return results;
};

export const getDriverDetailsLocationsByIds = async (payload: LocationByIdsRequest): Promise<LocationDetailsResponse[]> => {
  const deletePromises = payload.ids?.map(async (id) => {
    const { data } = await DataAPIService.api.get<LocationDetailsResponse>(`${payload.fleetId}${MAPS_ENDPOINT}/devices/${id}${payload.query || ''}`);
    return data;
  });

  const results = await Promise.all(deletePromises);
  return results;
};

export const getDeviceDetailsLocationsByIds = async (payload: LocationByIdsRequest): Promise<LocationDetailsResponse[]> => {
  const deletePromises = payload.ids?.map(async (id) => {
    const { data } = await DataAPIService.api.get<LocationDetailsResponse>(`${payload.fleetId}${MAPS_ENDPOINT}/devices/${id}${payload.query || ''}`);
    return data;
  });

  const results = await Promise.all(deletePromises);
  return results;
};
